// Preserve the saved caption independently of its enabled state.
export function flywheelCaptionValues(config = {}) {
  return {
    flywheelTextEnabled: config.flywheelTextEnabled === true,
    flywheelText: typeof config.flywheelText === "string" ? config.flywheelText : ""
  };
}
